
import { useEffect } from 'react'
import Select from 'react-select'
import { WTPPumpNumberDDLAPI } from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'

export const WTPPumpNumberDDL = (props) => {
    const { PumpNumberDDL, setPumpNumberDDL, IsPost,Category,SumpNumber } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = {
            M_WTP_PumpCategoryID: Category.ID,
            M_WTP_SumpID:SumpNumber.ID,
            M_UserID: UserID,
            token: token,
        }
        // if (UnitType.ID) {
        dispatch(WTPPumpNumberDDLAPI({ data }))
        // }
    }, [IsPost,Category.ID,SumpNumber.ID])

    const { WTPPumpNumberData } = useSelector(state => state.WTPPumpNumberDDL)

    useEffect(() => {
        handleWTPPumpNumberDDL()
    }, [WTPPumpNumberData])

    const handleWTPPumpNumberDDL = () => {
        // console.log(DeptDDLDataa)
        if (WTPPumpNumberData && WTPPumpNumberData.table && WTPPumpNumberData.table.length > 0) {
            let list = WTPPumpNumberData.table.map((item, index) => ({
                value: item.m_wtP_PumpID,
                label: item.pumpNumber,
            }))

            // setEmployeeDDL({
            //     DDL: list,
            //     ID: Flag === 'Update' ? rowData.m_EmployeeID : 0,
            //     Label: Flag === 'Update' ? rowData.employeeName : "Select...",
            // })
            setPumpNumberDDL({ ...PumpNumberDDL, DDL: list })
        }
        else {
            setPumpNumberDDL({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }
    }

    return (
        <div className="form-group">
            <label className="d-block" htmlFor="NameofEmployee"><b>Pump Number</b></label>
            <Select
                // isClearable
                // isRtl={isRtl}
                // className="ddl_width"
                isSearchable
                maxMenuHeight={150}
                value={{ value: PumpNumberDDL.ID, label: PumpNumberDDL.Label }}
                onChange={(e) => {
                    e ?
                        setPumpNumberDDL({ ...PumpNumberDDL, ID: e.value, Label: e.label })
                        :
                        setPumpNumberDDL({ ...PumpNumberDDL, ID: 0, Label: "Select..." })

                }}
                options={PumpNumberDDL.DDL}
            />
        </div>
    )
}